import { useRef } from "react";
import { AgGridReact } from "ag-grid-react";

import Actionbar from "src/components/common/actionbar/Authactionbar";
import { Message } from "src/components/common/form/Message";
import useFetchActionbarAuth from "src/hooks/useFetchActionbarAuth";

import { Content_TQC1040_R01 } from "./Content_TQC1040_R01";
import { SearchSection_TQC1040_R01 } from "./SearchSection_TQC1040_R01";
import { Table_TQC1040_R01 } from "./Table_TQC1040_R01";
import { TQC1040_R01Dto } from "./Dto_TQC1040_R01";

/**
 * 약품 수입검사 결과등록 컨테이너
 * MST4050_R01 입고 내역에 대한 수입검사 결과(검사값/검사자/비고)를 등록한다.
 */
export const Container_TQC1040_R01 = () => {
	useFetchActionbarAuth("TQC1040_R01");

	const gridRef = useRef<AgGridReact<TQC1040_R01Dto> | null>(null);

	const {
		clickable, setClickable,
		defaultTQC1040_R01Row,
		fetchData,
		handleSaveClick,
		handlePrintClick,
		initContainerData,
	} = Content_TQC1040_R01({ gridRef });

	return (
		<div className="content-container">
			<Actionbar
				onFetchClick={fetchData}
				onCreateClick={() => {}}
				onDeleteClick={() => {}}
				onSaveClick={handleSaveClick}
				onPrintClick={handlePrintClick}
				onExcelClick={() => {}}
				onInitClick={initContainerData}
			/>
			<SearchSection_TQC1040_R01 onEnterKeyDown={fetchData} />

			<div className="flex-1 flex">
				<div className="w-full h-full flex flex-col p-[12px] gap-[12px]">
					<Table_TQC1040_R01
						clickable={clickable}
						setClickable={setClickable}
						gridRef={gridRef}
						defaultTQC1040_R01Row={defaultTQC1040_R01Row()}
					/>
				</div>
			</div>

			<Message />
		</div>
	);
};
